export const router = state => state.router;



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/vuex/modules/router/getters.js